export function youtubePlayer(code) {
    let enabled = true;

    const state = { type: 'youtube', code };
    window.history.pushState(state, '');

    const template = document.getElementById('video-player-template')
    template.content.querySelector('.dialog').innerHTML = `
        <iframe width="560" height="315" src="https://www.youtube.com/embed/${code}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    `;
    
    const clone = document.importNode(template.content, true);
    document.body.appendChild(clone);
    
    const instance = document.getElementById('video-player');

    const closeWindow = () => {
        if (!enabled) {
            return;
        }

        enabled = false;
        document.body.removeChild(instance);
    }

    instance.querySelector('.mask').addEventListener('click', e => {
        e.preventDefault();
        closeWindow();
    });

    document.onkeydown = function(evt) {
        evt = evt || window.event;
        let isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        if (isEscape) {
            closeWindow();
        }
    };

    window.addEventListener('popstate', (event) => {
        closeWindow();
    });
}

export function videoPlayer(url) {
    let enabled = true;

    const state = { type: 'video', url };
    window.history.pushState(state, '');

    const template = document.getElementById('video-player-template');
    const sourceElement = template.content.querySelector('source');

    if (sourceElement) {
        sourceElement.setAttribute('src', url);
    } else {
        const videoElement = document.createElement('video');
        const sourceElement = document.createElement('source');

        videoElement.controls = true;
        videoElement.autoplay = true;
        videoElement.width = 560;
        videoElement.height = 315;

        sourceElement.src = url;
        sourceElement.type = "video/mp4";

        videoElement.appendChild(sourceElement);

        const dialog = template.content.querySelector('.dialog')

        const iframe = template.content.querySelector('iframe');

        if (iframe) {
            dialog.removeChild(iframe);
        }

        dialog.appendChild(videoElement);
    }

    const clone = document.importNode(template.content, true);
    document.body.appendChild(clone);
    
    const instance = document.getElementById('video-player');

    const closeWindow = () => {
        if (!enabled) {
            return;
        }

        enabled = false;
        document.body.removeChild(instance);
    }

    instance.querySelector('.mask').addEventListener('click', e => {
        e.preventDefault();
        closeWindow();
    });

    document.onkeydown = function(evt) {
        evt = evt || window.event;
        let isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        if (isEscape) {
            closeWindow();
        }
    };

    window.addEventListener('popstate', (event) => {
        closeWindow();
    });
}